import { useState, useEffect } from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { Loader2 } from 'lucide-react';
import { userService } from "../../_services";

function GoProFaq() {
    const [faqData, setFaqData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        try {
            const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
            const [userId, userName] = Usermeta_Data.split(':');
            
            getFaqList(userId, userName, '5'); // Pro FAQ
        } catch (error) {
            console.error('Error loading Pro FAQ:', error);
            setLoading(false);
        }
    }, []);

    const getFaqList = async (userId, userName, count) => {
        try {
            // PRESERVE EXACT API CALL - DO NOT CHANGE
            const apidata = await userService.Get_FAQ(userId, userName, count);
            
            if (apidata && apidata.length > 0) {
                setFaqData(apidata);
            }
            setLoading(false);
        } catch (error) {
            console.error('Error fetching Pro FAQ:', error);
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="flex items-center justify-center py-8">
                <Loader2 className="h-6 w-6 animate-spin text-brand-accent" />
            </div>
        );
    }

    if (faqData.length === 0) {
        return (
            <div className="text-center text-gray-500 py-8">
                No FAQ items available.
            </div>
        );
    }

    return (
        <Accordion type="single" collapsible className="w-full">
            {faqData.map((faq, index) => (
                <AccordionItem key={index} value={`item-${index}`}>
                    <AccordionTrigger className="text-left">
                        {faq.question || faq.title}
                    </AccordionTrigger>
                    <AccordionContent>
                        <div 
                            className="prose prose-sm max-w-none"
                            dangerouslySetInnerHTML={{ __html: faq.answer || faq.content || faq.description }}
                        />
                    </AccordionContent>
                </AccordionItem>
            ))}
        </Accordion>
    );
}

export default GoProFaq;
